import React from 'react';
import { Image } from 'office-ui-fabric-react/lib/Image';
import logo from '../../resources/images/logo.png';

function Logo() {
  return <Image src={logo} alt="Soccer Cup" />;
}

export default Logo;
